import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import React from "react";
import { IPlanType } from "../../../services/api/planEnrollment/types";
import { WSQueries } from "../../../query/WSQuery";
import { usePlanEnrollments } from "../../../query/benefits/usePlanEnrollments";
import { useGoToMyResourceDetailsHistory } from "../paths";

type Props = {
  planType: IPlanType;
  insuranceCoverageId: string;
  isCompactView?: boolean;
};

export const MyResourceInsuranceHistory: React.FC<Props> = ({
  planType,
  isCompactView,
  insuranceCoverageId
}) => {
  const goToMyResourceDetailsHistory = useGoToMyResourceDetailsHistory();

  const qPlanEnrollments = usePlanEnrollments({
    filter: {
      planType
    }
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        const enrollmentResources = qPlanEnrollmentsData.map(enrollment => ({
          resourceType: "PlanEnrollment",
          resourceId: enrollment.planEnrollmentId
        }));

        const insuranceCoverageResources = [
          {
            resourceType: "InsuranceCoverage",
            resourceId: insuranceCoverageId
          }
        ];

        const resources = [
          ...enrollmentResources,
          ...insuranceCoverageResources
        ];

        return (
          <ResourceHistory
            resources={resources}
            onViewAll={
              isCompactView
                ? () => goToMyResourceDetailsHistory(insuranceCoverageId)
                : undefined
            }
          />
        );
      }}
    </WSQueries>
  );
};
